import { useState } from 'react';

const getVal = require('lodash/get');

/* eslint complexity: ["error", 30] -- need to increase complexity */
const evaluatePopUpTrigger = (conditions, dataObj) => {
  // if no conditions then return true
  if (!conditions) {
    return true;
  }
  let trigger = false;
  // default OR operation
  conditions.forEach((condition) => {
    if (!trigger) {
      switch (condition.type) {
        case 'groupKeysCheck':
          for (let i = 0; i < condition.keysGroups.length; i += 1) {
            const group = condition.keysGroups[i];
            // check if this group keys are eligible for check
            let groupEligibleForCheck = true;
            if (group.condition && group.condition.checkDependsOn !== '') {
              const checkVal = getVal(dataObj, group.condition.checkDependsOn);
              if (group.condition.applicableValues.indexOf(checkVal) === -1) {
                groupEligibleForCheck = false;
              }
            }
            if (groupEligibleForCheck) {
              let atleastOneKeyPresent = false;
              for (let j = 0; j < group.keysToCheck.length; j += 1) {
                const keyVal = getVal(dataObj, group.keysToCheck[j]);
                if (keyVal !== '' && keyVal !== null && keyVal !== undefined) {
                  atleastOneKeyPresent = true;
                  break;
                }
              }
              if (!atleastOneKeyPresent) {
                trigger = true;
                break;
              }
            }
          }
          break;
        case 'allKeysCheck':
          {
            let groupEligibleForCheck = false;
            if (condition.condition && condition.condition.checkDependsOn !== '') {
              const checkVal = getVal(dataObj, condition.condition.checkDependsOn);
              if (condition.condition.mapValues.type === 'nonApplicableNonEmptyValues') {
                if (checkVal && condition.condition.mapValues.values.indexOf(checkVal) === -1) {
                  groupEligibleForCheck = true;
                }
              }
            }
            if (groupEligibleForCheck) {
              let allKeysPresent = true;
              for (let i = 0; i < condition.keysToCheck.length; i += 1) {
                const keyVal = getVal(dataObj, condition.keysToCheck[i]);
                if (keyVal === '' || keyVal === null || keyVal === undefined) {
                  allKeysPresent = false;
                  break;
                }
              }
              if (!allKeysPresent) {
                trigger = true;
              }
            }
          }
          break;
        case 'mapValues':
          {
            let shouldShowPopUp = false;
            // AND condition between mapConditions
            for (let i = 0; i < condition.mapConditions.length; i += 1) {
              const mapCondition = condition.mapConditions[i];
              const keyVal = getVal(dataObj, mapCondition.key);
              if (mapCondition.value === keyVal) {
                shouldShowPopUp = true;
              } else {
                shouldShowPopUp = false;
                break;
              }
            }
            if (shouldShowPopUp) {
              trigger = true;
            }
          }
          break;
        default: trigger = false;
      }
    }
  });
  return trigger;
};

/**
 * Manages pop-up modal state.
 *
 * Owns:
 * - showPopUp: the fieldId of the currently visible pop-up (empty string = none)
 * - evaluatePopUpId: the pop-up ID to evaluate trigger conditions against
 * - evaluatePopUpTrigger: evaluates conditions to determine if a pop-up should be shown
 */
const usePopUpState = () => {
  const [showPopUp, setShowPopUp] = useState('');
  const [evaluatePopUpId, setEvaluatePopUpId] = useState('');

  return {
    showPopUp,
    setShowPopUp,
    evaluatePopUpId,
    setEvaluatePopUpId,
    evaluatePopUpTrigger,
  };
};

export default usePopUpState;
